(function () {

  /* =========================================
   GLOBAL STATE — separate items per tab mode
  ========================================= */

  var bundleState = {
    mode: 'mix',
    mixItems: {},   // variantId → { quantity, price }
    bulkItems: {},  // variantId → { quantity, price }
    discountRules: [
      { qty: 10, discount: 15 },
      { qty: 20, discount: 17 },
      { qty: 30, discount: 20 }
    ],
    lastDiscounts: { mix: 0, bulk: 0 } // per-mode so tab switching doesn't misfire confetti
  };

  function activeItems() {
    return bundleState.mode === 'mix' ? bundleState.mixItems : bundleState.bulkItems;
  }

  function formatPrice(paise) {
    var amount = Math.round(paise / 100);
    return '₹' + amount.toLocaleString('en-IN');
  }

  function tabLabel(mode) {
    return mode === 'mix' ? 'Mix & Match Bundles' : 'Bulk Boxes';
  }

  function pushCTEvent(eventName, props) {
    if (window.clevertap && clevertap.event) {
      clevertap.event.push(eventName, props);
    }
  }


  /* =========================================
   SINGLE DELEGATED CLICK HANDLER
  ========================================= */

  document.addEventListener('click', function (e) {

    // Bundle tab switch
    var tab = e.target.closest('.bundle-tab');
    if (tab) {
      e.preventDefault();
      handleTabClick(tab);
      return;
    }

    // Mix & Match — Add to Box
    var addBtn = e.target.closest('.mix-match-actions .bundle-add-btn');
    if (addBtn) {
      e.preventDefault();
      handleMixAdd(addBtn);
      return;
    }

    // Mix & Match — Qty minus
    var qtyMinus = e.target.closest('.mix-match-actions .qty-minus');
    if (qtyMinus) {
      e.preventDefault();
      handleQtyChange(qtyMinus, -1);
      return;
    }

    // Mix & Match — Qty plus
    var qtyPlus = e.target.closest('.mix-match-actions .qty-plus');
    if (qtyPlus) {
      e.preventDefault();
      handleQtyChange(qtyPlus, 1);
      return;
    }

    // Bulk — qty option select
    var bulkOpt = e.target.closest('.bulk-option');
    if (bulkOpt) {
      e.preventDefault();
      handleBulkOption(bulkOpt);
      return;
    }

    // Bulk — Add to Box
    var bulkAdd = e.target.closest('.bulk-add-btn');
    if (bulkAdd) {
      e.preventDefault();
      handleBulkAdd(bulkAdd);
      return;
    }

    // Bulk — Remove
    var bulkRemove = e.target.closest('.bulk-remove-btn');
    if (bulkRemove) {
      e.preventDefault();
      handleBulkRemove(bulkRemove);
      return;
    }

    // Buy Now
    var buyBtn = e.target.closest('.bundle-buy-btn');
    if (buyBtn && !buyBtn.disabled) {
      e.preventDefault();
      handleBuyNow(buyBtn);
      return;
    }
  });


  /* =========================================
   TAB SWITCH
  ========================================= */

  function handleTabClick(tab) {
    document.querySelectorAll('.bundle-tab').forEach(function (t) {
      t.classList.remove('active');
    });
    tab.classList.add('active');

    var mode = tab.dataset.mode;
    bundleState.mode = mode;
    // NOTE: do NOT clear items — each mode keeps its own state
    toggleBundleMode(mode);
    updateBundleBar();

    pushCTEvent('tab_clicked', {
      tab_name: tabLabel(mode),
      page_url: window.location.href
    });
  }

  function toggleBundleMode(mode) {
    var items = activeItems();

    document.querySelectorAll('.bundle-product-card').forEach(function (card) {
      var mixUI = card.querySelector('.mix-match-actions');
      var bulkUI = card.querySelector('.bulk-box-actions');
      var variantId = card.dataset.variantId;

      if (mode === 'mix') {
        if (mixUI) { mixUI.classList.add('active'); }
        if (bulkUI) { bulkUI.classList.remove('active'); }
        restoreMixCard(card, variantId, items);
      } else {
        if (mixUI) { mixUI.classList.remove('active'); }
        if (bulkUI) { bulkUI.classList.add('active'); }
        restoreBulkCard(card, variantId, items);
      }
    });

    var disText = document.querySelector('.dis-txt');
    if (disText) {
      disText.innerHTML = 'Mix any products. Hit <strong>10 items</strong> for 25% off, <strong>15</strong> for 30%, <strong>20</strong> for 35%.';
    }
  }

  // Restore mix card to reflect saved state (or reset if not in box)
  function restoreMixCard(card, variantId, items) {
    var addBtn = card.querySelector('.mix-match-actions .bundle-add-btn');
    var qtySelector = card.querySelector('.mix-match-actions .bundle-qty-selector');
    var qtyVal = card.querySelector('.qty-value');

    if (variantId && items[variantId]) {
      // Product was previously added in this tab — restore qty UI
      if (addBtn) { addBtn.classList.add('hidden'); }
      if (qtySelector) { qtySelector.classList.remove('hidden'); }
      if (qtyVal) { qtyVal.textContent = items[variantId].quantity; }
    } else {
      if (addBtn) { addBtn.classList.remove('hidden'); }
      if (qtySelector) { qtySelector.classList.add('hidden'); }
      if (qtyVal) { qtyVal.textContent = '1'; }
    }
  }

  // Restore bulk card to reflect saved state (or reset if not in box)
  function restoreBulkCard(card, variantId, items) {
    var addBtn = card.querySelector('.bulk-add-btn');
    var removeBtn = card.querySelector('.bulk-remove-btn');

    if (variantId && items[variantId]) {
      // Product was previously added in this tab — restore in-box UI
      if (addBtn) { addBtn.classList.add('hidden'); }
      if (removeBtn) { removeBtn.classList.remove('hidden'); }
      card.classList.add('bundle-in-box');
    } else {
      if (addBtn) { addBtn.classList.remove('hidden'); }
      if (removeBtn) { removeBtn.classList.add('hidden'); }
      card.classList.remove('bundle-in-box');
      var options = card.querySelectorAll('.bulk-option');
      options.forEach(function (opt, i) {
        opt.classList.toggle('active', i === 0);
      });
    }
    updateBulkPriceDisplay(card);
  }


  /* =========================================
   MIX & MATCH HANDLERS
  ========================================= */

  function handleMixAdd(btn) {
    var card = btn.closest('.bundle-product-card');
    if (!card) { return; }

    var variantId = card.dataset.variantId;
    var price = Number(card.dataset.price) || 0;
    if (!variantId) { return; }

    bundleState.mixItems[variantId] = { quantity: 1, price: price };

    btn.classList.add('hidden');
    var qtySelector = card.querySelector('.mix-match-actions .bundle-qty-selector');
    if (qtySelector) { qtySelector.classList.remove('hidden'); }
    updateCardQty(card, variantId);
    updateBundleBar();

    pushCTEvent('add_to_box_clicked', {
      prd_name: card.dataset.itemTitle || '',
      price: Math.round(price / 100),
      tab_name: tabLabel(bundleState.mode)
    });
  }

  function handleQtyChange(btn, delta) {
    var card = btn.closest('.bundle-product-card');
    if (!card) { return; }

    var variantId = card.dataset.variantId;
    if (!variantId || !bundleState.mixItems[variantId]) { return; }

    bundleState.mixItems[variantId].quantity += delta;

    if (bundleState.mixItems[variantId].quantity <= 0) {
      delete bundleState.mixItems[variantId];
      var addBtn = card.querySelector('.mix-match-actions .bundle-add-btn');
      var qtySelector = card.querySelector('.mix-match-actions .bundle-qty-selector');
      if (addBtn) { addBtn.classList.remove('hidden'); }
      if (qtySelector) { qtySelector.classList.add('hidden'); }
    } else {
      updateCardQty(card, variantId);
    }
    updateBundleBar();
  }

  function updateCardQty(card, variantId) {
    var el = card.querySelector('.qty-value');
    if (el && bundleState.mixItems[variantId]) {
      el.textContent = bundleState.mixItems[variantId].quantity;
    }
  }


  /* =========================================
   BULK BOX HANDLERS
  ========================================= */

  function handleBulkOption(btn) {
    var parent = btn.closest('.bulk-options');
    if (!parent) { return; }
    parent.querySelectorAll('.bulk-option').forEach(function (el) {
      el.classList.remove('active');
    });
    btn.classList.add('active');

    var card = btn.closest('.bundle-product-card');
    if (!card) { return; }
    updateBulkPriceDisplay(card);

    // If already in box, update qty live
    var variantId = card.dataset.variantId;
    if (variantId && bundleState.bulkItems[variantId]) {
      bundleState.bulkItems[variantId].quantity = Number(btn.dataset.qty) || 0;
      updateBundleBar();
    }
  }

  function handleBulkAdd(btn) {
    var card = btn.closest('.bundle-product-card');
    if (!card) { return; }

    var selectedOption = card.querySelector('.bulk-option.active');
    if (!selectedOption) { return; }

    var qty = Number(selectedOption.dataset.qty) || 0;
    var variantId = card.dataset.variantId;
    var price = Number(card.dataset.price) || 0;
    if (!variantId || qty === 0) { return; }

    bundleState.bulkItems[variantId] = { quantity: qty, price: price };

    btn.classList.add('hidden');
    var removeBtn = card.querySelector('.bulk-remove-btn');
    if (removeBtn) { removeBtn.classList.remove('hidden'); }
    card.classList.add('bundle-in-box');
    updateBundleBar();

    pushCTEvent('add_to_box_clicked', {
      prd_name: card.dataset.itemTitle || '',
      price: Math.round(price / 100),
      tab_name: tabLabel(bundleState.mode)
    });
  }

  function handleBulkRemove(btn) {
    var card = btn.closest('.bundle-product-card');
    if (!card) { return; }

    var variantId = card.dataset.variantId;
    var removedItem = variantId ? bundleState.bulkItems[variantId] : null;
    if (variantId) { delete bundleState.bulkItems[variantId]; }

    btn.classList.add('hidden');
    var addBtn = card.querySelector('.bulk-add-btn');
    if (addBtn) { addBtn.classList.remove('hidden'); }
    card.classList.remove('bundle-in-box');
    updateBundleBar();

    if (removedItem) {
      pushCTEvent('prd_removed', {
        prd_name: card.dataset.itemTitle || '',
        quantity: removedItem.quantity,
        price: Math.round(removedItem.price / 100),
        tab_name: tabLabel(bundleState.mode)
      });
    }
  }

  function updateBulkPriceDisplay(card) {
    var activeOption = card.querySelector('.bulk-option.active');
    var qtyLabel = card.querySelector('.bulk-qty-label');
    var totalCalc = card.querySelector('.bulk-total-calc');
    if (!activeOption || !totalCalc) { return; }

    var qty = Number(activeOption.dataset.qty) || 0;
    var price = Number(card.dataset.price) || 0;
    if (qtyLabel) { qtyLabel.textContent = qty; }
    totalCalc.textContent = formatPrice(qty * price);
  }


  /* =========================================
   PROGRESS BAR + TOTAL
  ========================================= */

  /* =========================================
   CONFETTI — fires on each discount tier unlock
  ========================================= */
  function launchBundleConfetti() {
    var canvas = document.getElementById('bundle-confetti-canvas');
    if (!canvas) return;

    var bar = canvas.closest('.bundle-bottom-bar');
    var ctx = canvas.getContext('2d');
    canvas.width = bar ? bar.offsetWidth : 400;
    canvas.height = bar ? bar.offsetHeight : 100;
    canvas.style.display = 'block';

    var cx = canvas.width / 2;
    var cy = canvas.height;
    var colors = ['#ff6b6b', '#ffd93d', '#6bcb77', '#4d96ff', '#ff922b', '#cc5de8', '#f06595'];
    var particles = [];

    for (var i = 0; i < 80; i++) {
      var angle = Math.PI + Math.random() * Math.PI; // upward half-circle (π to 2π)
      var speed = Math.random() * 4 + 2;
      particles.push({
        x: cx + (Math.random() - 0.5) * canvas.width * 0.6,
        y: cy,
        w: Math.random() * 8 + 4,
        h: Math.random() * 4 + 2,
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: Math.random() * Math.PI * 2,
        rotSpeed: (Math.random() - 0.5) * 0.18,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        alpha: 1
      });
    }

    var startTime = Date.now();
    var duration = 2200;

    function draw() {
      var elapsed = Date.now() - startTime;
      if (elapsed > duration) {
        canvas.style.display = 'none';
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        return;
      }
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var fadeStart = duration * 0.5;
      particles.forEach(function (p) {
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.12; // gravity pulls back down
        p.rotation += p.rotSpeed;
        if (elapsed > fadeStart) {
          p.alpha = Math.max(0, 1 - (elapsed - fadeStart) / (duration - fadeStart));
        }
        ctx.save();
        ctx.globalAlpha = p.alpha;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      requestAnimationFrame(draw);
    }

    draw();
  }

  function updateBundleBar() {
    var items = activeItems();
    var totalQty = 0;
    var totalPrice = 0;

    Object.keys(items).forEach(function (key) {
      var item = items[key];
      totalQty += item.quantity;
      totalPrice += item.quantity * item.price;
    });

    var discount = 0;
    bundleState.discountRules.forEach(function (rule) {
      if (totalQty >= rule.qty) { discount = rule.discount; }
    });

    var modeKey = bundleState.mode;
    if (discount > bundleState.lastDiscounts[modeKey]) {
      launchBundleConfetti();
    }
    bundleState.lastDiscounts[modeKey] = discount;

    var discountedPrice = totalPrice - (totalPrice * discount / 100);

    var totalEl = document.querySelector('.bundle-total-price');
    if (totalEl) { totalEl.textContent = formatPrice(discountedPrice); }

    var originalEl = document.querySelector('.bundle-original-price');
    if (originalEl) {
      originalEl.textContent = discount > 0 ? formatPrice(totalPrice) : '';
      originalEl.classList.toggle('hidden', discount === 0);
    }

    var discountBadge = document.querySelector('.bundle-discount-badge');
    if (discountBadge) {
      discountBadge.textContent = discount > 0 ? ('-' + discount + '%') : '';
      discountBadge.classList.toggle('hidden', discount === 0);
    }

    updateProgress(totalQty);
  }

  function updateProgress(totalQty) {
    var milestones = [10, 20, 30];
    var nextTarget = null;
    for (var i = 0; i < milestones.length; i++) {
      if (totalQty < milestones[i]) { nextTarget = milestones[i]; break; }
    }

    var progressFill = document.querySelector('.bundle-progress-fill');
    var progressText = document.querySelector('.bundle-progress-text');

    var progress = Math.min((totalQty / 30) * 100, 100);
    if (progressFill) { progressFill.style.width = progress + '%'; }

    if (!progressText) { return; }

    if (totalQty === 0) {
      progressText.innerHTML = 'Add <strong>10 items</strong> to your box to unlock <strong>15% OFF</strong>';
    } else if (nextTarget !== null) {
      var remaining = nextTarget - totalQty;
      var nextDiscountRule = null;
      for (var j = 0; j < bundleState.discountRules.length; j++) {
        if (bundleState.discountRules[j].qty === nextTarget) {
          nextDiscountRule = bundleState.discountRules[j];
          break;
        }
      }
      var nextDiscount = nextDiscountRule ? nextDiscountRule.discount : 0;
      progressText.innerHTML = '<strong>' + totalQty + ' items</strong> in box — add <strong>' + remaining + ' more</strong> to unlock <strong>' + nextDiscount + '% OFF</strong>';
    } else {
      progressText.innerHTML = 'Hurray! <strong>20% OFF</strong> unlocked | Checkout Now 🎉';
    }
  }


  /* =========================================
   BUY NOW
  ========================================= */

  async function handleBuyNow(buyBtn) {
    var items = activeItems();
    var keys = Object.keys(items);
    if (keys.length === 0) {
      alert('Add some products to your box first!');
      return;
    }

    var cartItems = keys.map(function (id) {
      return { id: Number(id), quantity: items[id].quantity, properties: { '_bundleItem': '1' } };
    });

    // Compute totals for the CT event before any async work
    var ctTotalQty = 0, ctTotalPrice = 0;
    keys.forEach(function (id) {
      ctTotalQty += items[id].quantity;
      ctTotalPrice += items[id].quantity * items[id].price;
    });
    var ctDiscount = 0;
    bundleState.discountRules.forEach(function (rule) {
      if (ctTotalQty >= rule.qty) { ctDiscount = rule.discount; }
    });
    var ctDiscountAmount = Math.round(ctTotalPrice * ctDiscount / 100);

    pushCTEvent('bulk_buy_now_clicked', {
      product_list: keys.map(function (id) {
        var c = document.querySelector('.bundle-product-card[data-variant-id="' + id + '"]');
        return c ? (c.dataset.itemTitle || id) : id;
      }).join(', '),
      quantity_list: keys.map(function (id) { return items[id].quantity; }).join(', '),
      price_list: keys.map(function (id) { return Math.round(items[id].price / 100); }).join(', '),
      total_quantity: ctTotalQty,
      total_price: Math.round(ctTotalPrice / 100),
      discount_per: ctDiscount,
      discount_price: Math.round(ctDiscountAmount / 100),
      tab_name: tabLabel(bundleState.mode)
    });

    var originalText = buyBtn.textContent;
    buyBtn.textContent = 'Adding…';
    buyBtn.disabled = true;

    try {
      /* -------------------------------------------------------
         APPBREW APP FLOW
      ------------------------------------------------------- */
      var isApp = window.ReactNativeWebView || window.appbrew || window.appbrewSDK;
      if (isApp && window.appbrewSDK && window.appbrewSDK.addToCart) {
        for (var i = 0; i < cartItems.length; i++) {
          var item = cartItems[i];
          for (var q = 0; q < item.quantity; q++) {
            await window.appbrewSDK.addToCart(
              null,
              'gid://shopify/ProductVariant/' + item.id,
              1
            );
          }
        }
        if (typeof appBrewgotoCart === 'function') { appBrewgotoCart(); }
        return;
      }

      /* -------------------------------------------------------
         WEB FLOW — add to Shopify cart, then open GoKwik cart drawer
         Items tagged _bundleItem:'1' bypass cart quantity-limit UI
      ------------------------------------------------------- */
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      var body = { items: cartItems };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        var errJson = await response.json().catch(function () { return {}; });
        throw new Error(errJson.description || 'Could not add items to cart. Please try again.');
      }

      var data = await response.json();

      // Refresh cart drawer HTML sections
      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(data);
        cart.classList.remove('is-empty');
      }

      // GoKwik uses Shopify's cart-drawer element — open it explicitly so Buy Now
      // always shows the cart regardless of the theme's data-auto-open setting
      if (cart && typeof cart.open === 'function') {
        cart.open();
      } else {
        window.location.href = '/cart';
      }
    } catch (err) {
      console.error('Bundle buy now failed:', err);
      alert(err.message || 'Something went wrong. Please try again.');
    } finally {
      buyBtn.textContent = originalText;
      buyBtn.disabled = false;
    }
  }


  /* =========================================
   MUTATION OBSERVER — apply mode to new cards
   loaded by infinite scroll
  ========================================= */

  function applyModeToCard(card) {
    var mode = bundleState.mode;
    var items = activeItems();
    var variantId = card.dataset.variantId;
    var mixUI = card.querySelector('.mix-match-actions');
    var bulkUI = card.querySelector('.bulk-box-actions');

    if (mode === 'mix') {
      if (mixUI) { mixUI.classList.add('active'); }
      if (bulkUI) { bulkUI.classList.remove('active'); }
      restoreMixCard(card, variantId, items);
    } else {
      if (mixUI) { mixUI.classList.remove('active'); }
      if (bulkUI) { bulkUI.classList.add('active'); }
      restoreBulkCard(card, variantId, items);
    }
    updateBulkPriceDisplay(card);
  }

  function observeProductGrid() {
    var grid = document.getElementById('product-grid');
    if (!grid) { return; }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) { return; }
          // The added node itself might be a card wrapper
          var cards = node.querySelectorAll ? node.querySelectorAll('.bundle-product-card') : [];
          cards.forEach(applyModeToCard);
          // Also check if the node itself is a card
          if (node.classList && node.classList.contains('bundle-product-card')) {
            applyModeToCard(node);
          }
        });
      });
    });

    observer.observe(grid, { childList: true, subtree: true });
  }


  /* =========================================
   INIT — run after DOM is ready
  ========================================= */

  function init() {
    document.querySelectorAll('.bundle-product-card').forEach(function (card) {
      updateBulkPriceDisplay(card);
    });
    updateBundleBar();
    observeProductGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());

/* =========================================
   Contact-us form popup
  ========================================= */
document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.getElementById('bulk-buy-modal');
  document.querySelectorAll('.js-open-bulk-modal').forEach(function (btn) {
    btn.addEventListener('click', function () {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  });
  function closeModal() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('.js-close-bulk-modal').forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
}); 
